import React, { useEffect, useState } from "react";
import SupplierNavbar from "./SuppplierNavbar";
import SupplierSidebar from "./SupplierSidebar";
import "./Supplier.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { PieChart, Pie, Cell, Legend, Tooltip, ResponsiveContainer } from 'recharts';
import Axios from "../../../axios/axios";
import { useLocation } from 'react-router-dom';

const COLORS = ['#667eea', '#ffc107', '#28a745', '#dc3545'];

function SupplierReports() {
  const [supplier, setSupplier] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [filter, setFilter] = useState('monthly');
  const [customDates, setCustomDates] = useState({ from: '', to: '' });
  const location = useLocation();

useEffect(() => {
  if (window.innerWidth < 768) {
    setSidebarOpen(false);
  }
}, [location]);

  
  const [counts, setCounts] = useState({
    total: 0,
    delivered: 0,
    quotationRequested: 0,
    quotationApproved: 0
  });
  const [loading, setLoading] = useState(true);

 
  const pieData = [
    { name: 'Total Orders', value: counts.total },
    { name: 'Requested Orders', value: counts.quotationRequested },
    { name: 'Approved Orders', value: counts.quotationApproved },
    { name: 'Delivered Orders', value: counts.delivered },
  ];

  useEffect(() => {
    const storedSupplier = sessionStorage.getItem("supplierInfo");
    if (storedSupplier) {
      const supplierInfo = JSON.parse(storedSupplier);
      setSupplier(supplierInfo);
      fetchOrderCounts(supplierInfo.supplierId);
    }
  }, [filter, customDates]);

  

  const fetchOrderCounts = async (supplierId) => {
  try {
    setLoading(true);
    let params = {};
    
    
  
  if (filter === 'custom' && customDates.from && customDates.to) {
  const fromDate = new Date(customDates.from);
  fromDate.setHours(0, 0, 0, 0); // Set to start of day
  
  const toDate = new Date(customDates.to);
  toDate.setHours(23, 59, 59, 999); // Set to end of day

  params.orderDate = JSON.stringify({
    $gte: fromDate.toISOString(),
    $lte: toDate.toISOString()
  });


    } else if (filter === 'weekly') {
      const oneWeekAgo = new Date();
      oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
      params.orderDate = JSON.stringify({
        $gte: oneWeekAgo.toISOString()
      });
    } else if (filter === 'monthly') {
      const oneMonthAgo = new Date();
      oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
      params.orderDate = JSON.stringify({
        $gte: oneMonthAgo.toISOString()
      });
    } else if (filter === 'quarterly') {
      const threeMonthsAgo = new Date();
      threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
      params.orderDate = JSON.stringify({
        $gte: threeMonthsAgo.toISOString()
      });
    }

    const response = await Axios.get(`/order/${supplierId}/status-counts`, {
      params,
      headers: { "x-supplier-id": supplierId }
    });

    setCounts(response.data.counts);
  } catch (error) {
    console.error("Error fetching order counts:", error);
  } finally {
    setLoading(false);
  }
};






  return (
    <div className="enhanced-body">
      <SupplierNavbar
        supplier={supplier}
        setSupplier={setSupplier}
        toggleSidebar={() => setSidebarOpen(!sidebarOpen)}
      />

      <div className="container-fluid">
        <div className="row">
          {sidebarOpen && (
            <div className="col-md-2">
                                        <SupplierSidebar closeSidebar={() => {
              if (window.innerWidth < 768) setSidebarOpen(false);
            }} />
            </div>
          )}

          <div className={sidebarOpen ? "col-md-10" : "col-md-12"}>
            <div className="dashboard-main">
              <h2 className="dashboard-title mb-4">Sales Reports</h2>

              <div className="row mb-4">
                <div className="col-md-3">
                  <select
                    className="form-select shadow-sm"
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                  >
                    <option value="weekly">Weekly</option>
                    <option value="monthly">Monthly</option>
                    <option value="quarterly">Quarterly</option>
                    <option value="custom">Custom Range</option>
                  </select>
                </div>

                {filter === 'custom' && (
                  <div className="col-md-6 d-flex gap-2">
                    <input
                      type="date"
                      className="form-control"
                      value={customDates.from}
                      onChange={(e) => setCustomDates({ ...customDates, from: e.target.value })}
                    />
                    <input
                      type="date"
                      className="form-control"
                      value={customDates.to}
                      onChange={(e) => setCustomDates({ ...customDates, to: e.target.value })}
                    />
                  </div>
                )}
              </div>
              

              <div className="row mb-3">
  <div className="col-md-6">
    <div className="border rounded shadow-sm p-3 bg-light text-center">
      <h6 className="fw-bold text-primary">Total Orders ({filter.toUpperCase()})</h6>
      <p className="fs-4 mb-0">{counts.total}</p>
    </div>
  </div>
  <div className="col-md-6">
    <div className="border rounded shadow-sm p-3 bg-light text-center">
      <h6 className="fw-bold text-warning">Requested Orders ({filter.toUpperCase()})</h6>
      <p className="fs-4 mb-0">{counts.quotationRequested}</p>
    </div>
  </div>
</div>


              <div className="row mt-3 mt-md-0">
                <div className="col-md-12">
                  <div className="chart-container bg-white p-4 rounded shadow-sm">
                    <h4 className="mb-4 text-center">Order Distribution</h4>
  <ResponsiveContainer
  width="100%"
  height={window.innerWidth < 768 ? 360 : 300}
>
  <PieChart>
    <Pie
  data={pieData}
  dataKey="value"
  nameKey="name"
  cx="50%"
  cy="50%"
  outerRadius={100}
  fill="#8884d8"
  labelLine={false} // ✅ Removes the outer label lines
  label={({ cx, cy, midAngle, innerRadius, outerRadius, index }) => {
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) / 2;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor="middle"
        dominantBaseline="central"
        fontSize="18"
        fontWeight="bold"
      >
        {pieData[index].value > 0 ? pieData[index].value : ''}
      </text>
    );
  }}
>
  {pieData.map((entry, index) => (
    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
  ))}
</Pie>

    <Tooltip />
    <Legend layout="horizontal" verticalAlign="bottom" align="center" />
  </PieChart>
</ResponsiveContainer>

                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}




export default SupplierReports;